import { CardCategory } from 'src/components/InforCard/InfoCard.types'

export const PostGraduateCategory: Record<string, CardCategory> = {
  encerrado: {
    key: 'closed',
    label: 'Encerrado',
    backgroundColor: '#EFF1FF',
    badgeBackground: '#D1D9FF',
    badgeTextColor: '#3F3D87',
    titleColor: '#111111'
  },
  'em vigor': {
    key: 'active',
    label: 'Em vigor',
    backgroundColor: '#EFF1FF',
    badgeBackground: '#D1EDE4',
    badgeTextColor: '#2D6C03',
    titleColor: '#111111'
  },
  'em breve': {
    key: 'soon',
    label: 'Em breve',
    backgroundColor: '#EFF1FF',
    badgeBackground: '#C6E2FF',
    badgeTextColor: '#1658BC',
    titleColor: '#111111'
  }
}

export const getPostGraduateCategory = (key?: string): CardCategory => {
  if (!key) return PostGraduateCategory['em breve']
  return (
    PostGraduateCategory[key.trim().toLowerCase()] ||
    PostGraduateCategory['em breve']
  )
}
